// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3d6X8","title":"Info_title__3weFp","selects":"Info_selects__HWUmH","requiredAsterisk":"Info_requiredAsterisk__2ETVA"};